import graphql from './graphql';

const query = /* GraphQL */ `
  query UserAchievement_usedAppFirstTime($userId: ID!) {
    UserAchievement_usedAppFirstTime(userId: $userId) {
      completed
      progress
    }
  }
`;

const UserAchievementUsedAppFirstTime = async ({ userId }) =>
  graphql(query, { userId })
    .then(
      // eslint-disable-next-line camelcase
      ({ UserAchievement_usedAppFirstTime }) => UserAchievement_usedAppFirstTime
    )
    .catch(err => err);

export default UserAchievementUsedAppFirstTime;
